import axios from "axios";
import { commonservices } from "./CommonServices";

let tokenValue = "";
const controllersMap = new Map();

const appendFormValue = (formData, key, value) => {
  if (value === null || value === undefined || value === "null" || value === "undefined") {
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((item) => {
      if (item !== null && item !== undefined && item !== "null" && item !== "undefined") {
        formData.append(key, item);
      }
    });
    return;
  }

  formData.append(key, value);
};

// DATA SEND LIKE BELOW OBJECT
// {
//   method: "",
//   url: "",
//   body: {
//     username: "",
//     password: "",
//   }
// }

// IF formType PARAMETER IS TRUE THEN IT WILL BE FORM DATA OTHERWISE NORMAL JSON

export const apiCall = async (data, formType, prevApiAbort) => {
  tokenValue = localStorage.getItem("Token");

  if (controllersMap.has(data.url)) {
    const existingController = controllersMap.get(data.url);
    existingController.abort();
    controllersMap.delete(data.url);
  }

  const controller = new AbortController();
  controllersMap.set(data.url, controller);

  if (tokenValue !== "" && tokenValue !== undefined && tokenValue !== null) {
    try {
      let formData = new FormData();

      if (formType) {
        for (const [key, value] of Object.entries(data?.body || {})) {
          if (
            typeof value === "object" &&
            Array.isArray(value) &&
            key !== "componentjson"
          ) {
            if (value.length > 0 && typeof value[0] === "object") {
              value?.map((item, index) => {
                for (const [nestedKey, nestedValue] of Object.entries(item)) {
                  if (nestedValue !== null && nestedValue !== undefined && nestedValue !== "null") {
                    formData.append(`${key}[${index}].${nestedKey}`, nestedValue);
                  }
                }
              });
            } else {
              appendFormValue(formData, key, value);
            }
          } else {
            appendFormValue(formData, key, value);
          }
        }
      }
      let apiCallObj = {
        method: data.method,
        url: data?.url,
        maxBodyLength: Infinity,
        data: formType ? formData : data?.body,
        headers: formType
          ? commonservices.getHeadersFromData()
          : commonservices.getHeaders(),
      };
      if (prevApiAbort) {
        apiCallObj = {
          ...apiCallObj,
          signal: controller.signal,
        };
      }
      let response = await axios(apiCallObj);
      controllersMap.delete(data.url);
      return response?.data;
    } catch (error) {
      if (axios.isCancel(error)) {
      } else {
      }
      controllersMap.delete(data.url);
      return error;
    }
  } else {
    try {
      let formData = new FormData();

      if (formType) {
        for (const [key, value] of Object.entries(data?.body)) {
          if (
            typeof value === "object" &&
            Array.isArray(value) &&
            key !== "componentjson"
          ) {
            if (value.length > 0 && typeof value[0] === "object") {
              value?.map((item, index) => {
                for (const [nestedKey, nestedValue] of Object.entries(item)) {
                  formData.append(`${key}[${index}].${nestedKey}`, nestedValue);
                }
              });
            } else {
              appendFormValue(formData, key, value);
            }
          } else {
            appendFormValue(formData, key, value);
          }
        }
      }
      let response = await axios({
        method: data.method,
        url: data?.url,
        data: formType ? formData : data?.body,
      });
      return response?.data;
    } catch (error) {
      return error;
    }
  }
};

export const apiCallAdvanced = async (data, formType) => {
  tokenValue = localStorage.getItem("Token");
  if (tokenValue !== "" && tokenValue !== undefined && tokenValue !== null) {
    try {
      let formData = new FormData();
      if (formType) {
        for (const [key, value] of Object.entries(data?.body)) {
          if (
            typeof value === "object" &&
            Array.isArray(value) &&
            key !== "componentjson"
          ) {
            if (value.length > 0 && typeof value[0] === "object") {
              value?.map((item, index) => {
                if (typeof item === "object" && !Array.isArray(item)) {
                  for (const [nestedKey, nestedValue] of Object.entries(item)) {
                    formData.append(`${key}[${index}].${nestedKey}`, nestedValue);
                  }
                } else {
                  appendFormValue(formData, key, item);
                }
              });
            } else {
              appendFormValue(formData, key, value);
            }
          } else {
            appendFormValue(formData, key, value);
          }
        }
      }
      let response = await axios({
        method: data.method,
        url: data?.url,
        maxBodyLength: Infinity,
        data: formType ? formData : data?.body,
        headers: formType
          ? commonservices.getHeadersFromData()
          : commonservices.getHeaders(),
      });
      return response?.data;
    } catch (error) {
      return error;
    }
  } else {
    try {
      let formData = new FormData();

      if (formType) {
        for (const [key, value] of Object.entries(data?.body)) {
          if (
            typeof value === "object" &&
            Array.isArray(value) &&
            key !== "componentjson"
          ) {
            if (value.length > 0 && typeof value[0] === "object") {
              value?.map((item, index) => {
                for (const [nestedKey, nestedValue] of Object.entries(item)) {
                  formData.append(`${key}[${index}].${nestedKey}`, nestedValue);
                }
              });
            } else {
              appendFormValue(formData, key, value);
            }
          } else {
            appendFormValue(formData, key, value);
          }
        }
      }
      let response = await axios({
        method: data.method,
        url: data?.url,
        data: formType ? formData : data?.body,
      });
      return response?.data;
    } catch (error) {
      return error;
    }
  }
};

export const apiCallformData = async (data, formType) => {
  if (tokenValue !== "" && tokenValue !== undefined && tokenValue !== null) {
    try {
      let response = await axios({
        method: "POST",
        url: data?.url,
        maxBodyLength: Infinity,
        data: formType ? data?.body : data?.body,
        headers: formType
          ? commonservices.getHeadersFromData()
          : commonservices.getHeaders(),
      });
      return response?.data;
    } catch (error) {
      return error;
    }
  } else {
    try {
      let formData = new FormData();

      if (formType) {
        for (const [key, value] of Object.entries(data?.body)) {
          if (
            typeof value === "object" &&
            Array.isArray(value) &&
            key !== "componentjson"
          ) {
            value?.map((item, index) => {
              for (const [nestedKey, nestedValue] of Object.entries(item)) {
                formData.append(`${key}[${index}].${nestedKey}`, nestedValue);
              }
            });
          } else {
            formData.append(`${key}`, value);
          }
        }
      }
      let response = await axios({
        method: data.method,
        url: data?.url,
        data: formType ? formData : data?.body,
        headers: formType
          ? commonservices.getHeadersFromData()
          : commonservices.getHeaders(),
      });
      return response?.data;
    } catch (error) {
      return error;
    }
  }
};
